import { formatDate } from '@btime/helpers'
import moment from 'moment'

export const clearName = string => (string ? string.replace(/\s/g, '').toLowerCase() : string)

export const getUserNames = serviceOrder => {
  const { user } = serviceOrder
  const registryNumber = user.fieldValues.find(
    fieldValue => fieldValue.field && fieldValue.field.name === 'Número do Registro'
  )
  return {
    userName: user.name,
    userCode: registryNumber ? registryNumber.value : 'N/A'
  }
}

export const getReplyValue = reply => {
  if (!reply) {
    return 'N/A'
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  return reply.value
}

export const getAddressValue = serviceOrder => {
  if (!serviceOrder.address) {
    const fieldFound = serviceOrder.place.fieldValues.find(fieldValue => fieldValue.field.name === 'Endereço')
    if (!fieldFound) {
      return '**N/A**'
    }
    return fieldFound.value.search
  }

  return serviceOrder.address.search
}

export const getPlaceFieldValue = (place, fieldValueName) => {
  const fieldFound = place.fieldValues.find(fieldValue => fieldValue.field.name === fieldValueName)
  if (!fieldFound) {
    return ''
  }
  return fieldFound.value
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const findReplyByQuestionName = (replies, name) => {
  return replies.find(reply => clearName(reply.question.name) === clearName(name))
}

export const filterRepliesByParentReference = (replies, reference) => {
  return replies.filter(
    reply => reply.question.parentReference && reply.question.parentReference.indexOf(reference) === 0
  )
}

export const findReplyByReference = (replies, reference) => {
  return replies.find(reply => reply.question.reference === reference)
}

export const findParentReply = (replies, reply) => {
  return replies.find(r => r.question.reference === reply.question.parentReference)
}

export const getReplyValueFieldOrDefault = (reply, field = 'value', defaultValue = '') => {
  if (!reply || reply[field] === undefined) {
    return defaultValue
  }
  return reply[field]
}

export const getDate = reply => {
  if (!reply) {
    return 'Não informada'
  }
  if (typeof reply === 'string') {
    return formatDate('DD/MM/YYYY', reply)
  }
  if (typeof reply === Date) {
    return formatDate('DD/MM/YYYY', reply)
  }
  return formatDate('DD/MM/YYYY', reply.value)
}

export const addBusinessDays = (originalDate, numDaysToAdd) => {
  const date = moment.isMoment(originalDate) ? originalDate : moment(originalDate)
  const sunday = 0
  const saturday = 6
  let daysRemaining = numDaysToAdd - 1

  const newDate = date.clone()

  while (daysRemaining > 0) {
    newDate.add(1, 'days')
    if (newDate.day() !== sunday && newDate.day() !== saturday) {
      daysRemaining--
    }
  }

  return newDate
}

export const toCurrency = value => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

  return formatter.format(value)
}

export const getAssets = value => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

  return formatter.format(value)
}

export const getAssetIds = serviceOrder => {
  let assetsIds = []
  const mainReply = findReplyByQuestionName(serviceOrder.replies, 'Equipamentos trocados')
  const mainAssetReply = findReplyByReference(serviceOrder.replies, mainReply.question.reference)
  const assets = filterRepliesByParentReference(serviceOrder.replies, mainAssetReply.question.reference)
  const assetsValues = mountAssetsValues(assets)
  let assetsIdsTmp = assetsValues.map(asset => {
    return asset.id
  })
  assetsIds = assetsIds.concat(assetsIdsTmp)
  return assetsIds
}

export const currencyToNumber = value => {
  if (!value) {
    return 0
  }
  if (typeof value == 'number') {
    return value
  }
  return Number(value.toString().replace(',', '#').replace('.', '').replace('#', '.'))
}

export const getFieldValue = (fields, fieldName) => {
  return fields.fieldValues.find(field => field.field.name === fieldName)
}

export const mountAssetsValues = replies => {
  const saida = {}
  replies.forEach(reply => {
    if (!saida[reply.blockIndex]) {
      saida[reply.blockIndex] = {}
    }
    const indexData = saida[reply.blockIndex]
    if (reply?.question?.type?.name === 'asset') {
      indexData.id = reply.value.id
      indexData[reply.question.name] = reply.value.name
    } else {
      indexData[reply.question.name] = reply.value
      indexData[reply.question.id] = reply.value
    }
  })
  return Object.values(saida)
}
